import type { SVGProps } from 'react';

import { cn } from '@/utils/styles';

export type LogoProps = SVGProps<SVGSVGElement> & {
  /** Width of the SVG in pixels (or any CSS length string). Height is derived from the logo's fixed aspect ratio. Defaults to `48`. */
  size?: number | string;
  /** Color scheme of the logo. `'dark'` renders on dark backgrounds (light fill); `'light'` renders on light backgrounds (dark fill). Defaults to `'dark'`. */
  variant?: 'dark' | 'light';
  strokeWidth?: number;
  /** Shows the `tlai-loader-animated` CSS animation on the logo (e.g. during app loading). */
  loading?: boolean;
};

const ASPECT_RATIO = 902 / 935;

export const Logo = ({ size = 48, variant = 'dark', className, loading, ...props }: LogoProps) => {
  const color = variant === 'light' ? '#1A1A1A' : '#F4F4F4';
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={typeof size === 'number' ? size * ASPECT_RATIO : size}
      viewBox="0 0 902 935"
      fill="currentColor"
      className={cn('shrink-0', { 'tlai-loader-animated': loading }, className)}
      aria-label="Tessera Labs AI Logo"
      preserveAspectRatio="xMidYMid meet"
      {...props}
    >
      <path d="M654.91 532.57L505.26 682.22V913.65L886.34 532.57H654.91Z" fill={color} />
      <path d="M853.61 423.47L450.71 20.5801L47.8198 423.47H279.25L450.71 252.01L622.18 423.47H853.61Z" fill={color} />
      <path d="M15.0801 532.57L396.16 913.65V682.22L246.51 532.57H15.0801Z" fill={color} />
    </svg>
  );
};

Logo.displayName = 'Logo';
